'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _parseInt = require('babel-runtime/core-js/number/parse-int');

var _parseInt2 = _interopRequireDefault(_parseInt);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redial = require('redial');

var _reactRedux = require('react-redux');

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _glamor = require('glamor');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _assets = require('redux/modules/assets');

var _components = require('components');

var _AssetsGrid = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/AssetsGrid');

var _AssetsGrid2 = _interopRequireDefault(_AssetsGrid);

var _Button = require('@quixeltools/quixel-ui-library/dist/components/common/essentials/Button');

var _Button2 = _interopRequireDefault(_Button);

var _AssetsGridItem = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/AssetsGridItem');

var _AssetsGridItem2 = _interopRequireDefault(_AssetsGridItem);

var _css = require('@quixeltools/quixel-ui-library/dist/utils/css');

var _fonts = require('@quixeltools/quixel-ui-library/dist/utils/fonts');

var _YoutubeTutorialBanner = require('@quixeltools/quixel-ui-library/dist/components/megascans/marketing/YoutubeTutorialBanner');

var _YoutubeTutorialBanner2 = _interopRequireDefault(_YoutubeTutorialBanner);

var _user2 = require('redux/modules/user');

var _assetDownloads = require('redux/modules/assetDownloads');

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nowDate = Date.now() / 1000;
var days = 60 * 60 * 24 * 3;

var getAssetImage = function getAssetImage(asset, pixelRatio) {
  if (!asset.previews) {
    //SAFE CHECK -- in case asset data gets curropted from dashboard
    return {
      smuri: "",
      uri: "",
      aspectRatio: 1
    };
  }
  var getAspectRatio = _ramda2.default.compose(_ramda2.default.apply(_ramda2.default.divide), _ramda2.default.map(_parseInt2.default), _ramda2.default.split('x'), _ramda2.default.prop('relativeSize'));
  var aspectRatio = getAspectRatio(asset.previews);

  var imageUrl = pixelRatio > 1 ? asset.previews.images.thumbRetinaJpg : asset.previews.images.thumbJpg;
  if (asset.previews.images.thumbGridJpg) {
    imageUrl = pixelRatio > 1 ? asset.previews.images.thumbGridRetinaJpg : asset.previews.images.thumbGridJpg;
  }
  return {
    smuri: asset.previews.images.thumbGridJpg || asset.previews.images.thumbJpg,
    uri: imageUrl,
    aspectRatio: aspectRatio
  };
};
var submitButton = (0, _glamor.css)({
  position: 'relative',
  margin: '0 auto',
  marginTop: '1rem'
}, (0, _css.minWidth)(_css.breakpoints.medium)({
  display: 'block'
}));
var icon = (0, _glamor.css)((0, _css.bgCover)('/icons/asset_not_found.png'), {
  width: (0, _css.unitRem)(4),
  height: (0, _css.unitRem)(4), display: 'inline-block' }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  width: (0, _css.unitRem)(2),
  height: (0, _css.unitRem)(2)
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  width: (0, _css.unitRem)(3),
  height: (0, _css.unitRem)(3)
}));
var boldText = (0, _glamor.css)(_fonts.H2, {
  display: 'block',
  paddingBottom: (0, _css.unitRem)(1),
  marginTop: (0, _css.unitRem)(1.5),
  color: _css.colors.white,
  textTransform: 'uppercase'
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: (0, _css.unitRem)(1.5)
}));

var getAssetLowResImage = function getAssetLowResImage(asset) {
  return asset.previews.images.tiny;
};

var getAssetSize = function getAssetSize(asset) {
  var relativeSize = _ramda2.default.path(['previews', 'relativeSize'])(asset);

  var _R$compose = _ramda2.default.compose(_ramda2.default.map(_parseInt2.default), _ramda2.default.split('x'))(relativeSize),
      _R$compose2 = (0, _slicedToArray3.default)(_R$compose, 2),
      cols = _R$compose2[0],
      rows = _R$compose2[1];

  return { rows: rows, cols: cols };
};

var isSurface = _ramda2.default.pathEq(['categories', '0'], 'surface');

var noneFoundMessage = (0, _glamor.css)({
  display: 'block',
  color: _css.colors.gray,
  fontSize: '1rem',
  margin: 'auto',
  textAlign: 'center',
  fontWeight: '300',
  paddingLeft: (0, _css.unitRem)(0.7),
  paddingRight: (0, _css.unitRem)(0.7),
  marginTop: '99px',
  marginBottom: '99px'

}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginTop: '4em',
  fontSize: '0.9rem'
}));

var promotionalContainer = (0, _glamor.css)({
  marginTop: '99px'
});

var AssetsGrid = (_dec = (0, _redial.provideHooks)({
  defer: function defer(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        query = _ref.query,
        params = _ref.params;
    var view = params.view,
        pack = params.pack,
        collectionId = params.collectionId;
    var type = query.type,
        biome = query.biome,
        region = query.region,
        category = query.category,
        subCategory = query.subCategory,
        sort = query.sort,
        sortOrder = query.sortOrder,
        search = query.search,
        filter = query.filter;

    var state = getState();

    var isArchviz = state.user && state.user.subscription && state.user.subscription.isArchViz || state.routing.locationBeforeTransitions.pathname.indexOf('library/archviz') > -1;
    if (state.auth && state.auth.loggedIn && view === 'free') {
      dispatch((0, _user2.markFreeSeen)());
    }
    return dispatch((0, _assets.loadAssetsPage)({
      collectionId: collectionId,
      pack: pack,
      view: view,
      type: type,
      biome: biome,
      region: region,
      category: category,
      subCategory: subCategory,
      sort: sort,
      sortOrder: sortOrder,
      search: search,
      filter: filter && filter.split('|')
    }, false, isArchviz));
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    assets: state.assets.assets,
    favorites: state.assets.favorites,
    acquired: state.assets.acquired,
    loading: state.assets.loading,
    appendLoading: state.assets.appendLoading,
    page: state.assets.page,
    loggedIn: state.auth.loggedIn,
    fullAssets: state.assets.fullAssets,
    freeAssetDrops: state.assets.freeAssetDrops,
    downloadRequesting: state.assetDownloads.downloadRequesting,
    acquiringAsset: state.assetDownloads.acquiringAsset,
    user: state.user,
    loadingFeatured: state.assets.loadingFeatured
  };
}, { loadAssetsPage: _assets.loadAssetsPage, addToFavorites: _assets.addToFavorites, removeFromFavorites: _assets.removeFromFavorites, acquireAsset: _assetDownloads.acquireAsset, requestAssetDownload: _assetDownloads.requestAssetDownload, loadFullAsset: _assets.loadFullAsset, loadFreeAssetsDrop: _assets.loadFreeAssetsDrop, markFreeSeen: _user2.markFreeSeen }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AssetsGrid, _React$Component);

  function AssetsGrid(props) {
    (0, _classCallCheck3.default)(this, AssetsGrid);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AssetsGrid.__proto__ || (0, _getPrototypeOf2.default)(AssetsGrid)).call(this, props));

    _this.gettingFullAssetForDownloadIDs = [];
    _this.resizeTimer = null;
    _this.loadMoreAssets = _this.loadMoreAssets.bind(_this);
    _this.handleFavoriteToggle = _this.handleFavoriteToggle.bind(_this);
    _this.handleDownloadClick = _this.handleDownloadClick.bind(_this);
    _this.downloadAsset = _this.downloadAsset.bind(_this);
    _this.requestDownload = _this.requestDownload.bind(_this);
    _this.onWindowResize = _this.onWindowResize.bind(_this);
    if (!__SERVER__) {
      window.addEventListener('resize', _this.onWindowResize);
      _this.state = {
        windowSize: 0,
        pixelRatio: (0, _utils.getDevicePixelRatio)()
      };
    } else {
      _this.state = {};
    }
    return _this;
  }

  (0, _createClass3.default)(AssetsGrid, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!__SERVER__) {
        window.removeEventListener('resize', this.onWindowResize);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (!this.calling && !this.props.freeAssetDrops && newProps.user && newProps.user.drops && newProps.user.drops.assetIds) {
        this.calling = true;
        this.props.loadFreeAssetsDrop(newProps.user.drops.assetIds);
      }
    }
  }, {
    key: 'onWindowResize',
    value: function onWindowResize() {
      var _this2 = this;

      if (!this.resizeTimer) {
        this.resizeTimer = setTimeout(function () {
          _this2.setState({ windowSize: window.innerWidth });
          _this2.resizeTimer = null;
        }, 200);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.user.loaded !== nextProps.user.loaded || this.props.freeAssetDrops !== nextProps.freeAssetDrops) {
        //in case archviz vas signed in, reload archviz assets
        this.loadMoreAssets(nextProps);
      }
      return this.props.assets !== nextProps.assets || this.props.favorites !== nextProps.favorites || this.props.loading !== nextProps.loading || this.props.freeAssetDrops !== nextProps.freeAssetDrops || this.props.appendLoading !== nextProps.appendLoading || this.props.loadingFeatured !== nextProps.loadingFeatured || this.props.user.loaded !== nextProps.user.loaded || this.state !== nextState;
    }
  }, {
    key: 'handleDownloadClick',
    value: function handleDownloadClick(assetId) {
      var _this3 = this;

      var asset = this.props.fullAssets[assetId];
      if (this.gettingFullAssetForDownloadIDs.indexOf(assetId) === -1) {
        this.gettingFullAssetForDownloadIDs.push(assetId);
        if (!asset) {
          this.props.loadFullAsset(assetId).then(function (res) {
            _this3.downloadAsset(res.asset, assetId);
          });
        } else {
          this.downloadAsset(asset, assetId);
        }
      }
    }
  }, {
    key: 'downloadAsset',
    value: function downloadAsset(asset, assetId) {
      var _this4 = this;

      var _props = this.props,
          requestAssetDownload = _props.requestAssetDownload,
          user = _props.user;

      // Allow free assets only for subscribers

      if (!asset.acl && asset.points === 0) {
        var subscribed = (0, _utils.isActiveSubscriber)(user);

        if (!subscribed) {
          var megascansTrial = user.megascansTrial;

          if (_underscore2.default.isEmpty(megascansTrial)) {
            var assetIndex = this.gettingFullAssetForDownloadIDs.indexOf(assetId);
            if (assetIndex !== -1) {
              this.gettingFullAssetForDownloadIDs.splice(assetIndex, 1);
            }

            return this.context.dialogs.custom(_react2.default.createElement(_components.TrialPopup, null));
          } else {
            if (!(0, _utils.isActiveSubscriber)(user)) return this.context.dialogs.custom(_react2.default.createElement(_components.TrialPopup, { trailExpired: true }));
          }
        }
      }

      if (asset.acl || asset.points === 0) {
        this.requestDownload(assetId);
      } else {
        var _props2 = this.props,
            _user = _props2.user,
            _acquireAsset = _props2.acquireAsset;


        _acquireAsset({
          assetId: assetId,
          resolution: _user.subscription.accessResolution,
          cost: asset.points || 1,
          exrAccess: _user.subscription.exrAccess
        }).then(function (res) {
          _this4.requestDownload(assetId);
        });
      }
    }
  }, {
    key: 'requestDownload',
    value: function requestDownload(assetId) {
      var asset = this.props.fullAssets[assetId];
      this.props.requestAssetDownload({
        assetId: assetId,
        asset: asset,
        isFree: asset.points === 0
      });
      var assetIndex = this.gettingFullAssetForDownloadIDs.indexOf(assetId);
      if (assetIndex != -1) {
        this.gettingFullAssetForDownloadIDs.splice(assetIndex, 1);
      }
    }
  }, {
    key: 'handleFavoriteToggle',
    value: function handleFavoriteToggle(id, favorited) {
      var _props3 = this.props,
          addToFavorites = _props3.addToFavorites,
          removeFromFavorites = _props3.removeFromFavorites;

      if (favorited) {
        removeFromFavorites(id);
      } else {
        addToFavorites(id);
      }
    }
  }, {
    key: 'loadMoreAssets',
    value: function loadMoreAssets(newProps) {
      var reload = !!newProps;
      var _props4 = this.props,
          loadAssetsPage = _props4.loadAssetsPage,
          page = _props4.page,
          _props4$params = _props4.params,
          pack = _props4$params.pack,
          view = _props4$params.view,
          collectionId = _props4$params.collectionId,
          _props4$router$locati = _props4.router.location.query,
          type = _props4$router$locati.type,
          biome = _props4$router$locati.biome,
          region = _props4$router$locati.region,
          category = _props4$router$locati.category,
          subCategory = _props4$router$locati.subCategory,
          sort = _props4$router$locati.sort,
          sortOrder = _props4$router$locati.sortOrder,
          search = _props4$router$locati.search,
          filter = _props4$router$locati.filter;


      try {
        var propsLocation = this.props.location;
        var windowLocation = window.location;

        var pagePath = propsLocation.pathname || windowLocation.pathname;
        var browserPath = windowLocation.pathname;

        if (propsLocation.search != windowLocation.search || pagePath != browserPath) {
          return;
        }
      } catch (e) {}
      var user = reload ? newProps.user : this.props.user;
      var isArchviz = user && user.subscription && user.subscription.isArchViz || this.props.location.pathname.indexOf('library/archviz') > -1;

      loadAssetsPage({
        page: !!reload ? page : page + 1,
        collectionId: collectionId,
        pack: pack,
        view: view,
        type: type,
        biome: biome,
        region: region,
        category: category,
        subCategory: subCategory,
        sort: sort,
        sortOrder: sortOrder,
        search: search,
        filter: filter && filter.split('|')
      }, true, isArchviz, reload);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      if (!__CLIENT__) {
        return null;
      }
      var _props5 = this.props,
          assets = _props5.assets,
          favorites = _props5.favorites,
          acquired = _props5.acquired,
          isLoading = _props5.loading,
          isLoadingMore = _props5.appendLoading,
          loggedIn = _props5.loggedIn,
          loadingFeatured = _props5.loadingFeatured,
          view = _props5.params.view,
          user = _props5.user;


      var isNew = false;
      var typeColor = "";
      var is3D = false;
      var assetType = "";
      var assetName = "";
      var isFav = false;
      var isAcquired = false;
      var pixelRatio = this.state.pixelRatio;


      var gridAssets = assets && assets.toArray && assets.toArray() || [];

      var userFreeAssets = [];
      var remainingTimeInMills = 0;
      if (loggedIn && user.drops && user.drops.assetIds) {
        userFreeAssets = user.drops && user.drops.assetIds;
        remainingTimeInMills = user.drops && user.drops.remainingTimeInMills;
      }

      return !loadingFeatured && assets && assets.toArray && assets.toArray().length ? _react2.default.createElement(
        _AssetsGrid2.default,
        {
          loadMore: this.loadMoreAssets,
          isLoadingMore: isLoadingMore || !gridAssets.length,
          windowSize: this.state.windowSize
        },
        gridAssets.map(function (asset) {
          var downloadInitiated = _this5.gettingFullAssetForDownloadIDs.indexOf(asset.id) != -1;
          var isDownloading = _this5.props.downloadRequesting || _this5.props.acquiringAsset || downloadInitiated;

          var _getAssetImage = getAssetImage(asset, pixelRatio),
              smuri = _getAssetImage.smuri,
              uri = _getAssetImage.uri,
              aspectRatio = _getAssetImage.aspectRatio;

          var assetData = (0, _utils.getAssetNameType)(asset);
          typeColor = assetData.color;
          assetType = assetData.type;
          is3D = assetData.is3D;
          assetName = (0, _utils.getAssetName)(asset, true, true, assetType);

          isFav = loggedIn && favorites && favorites.indexOf(asset.id) != -1;
          isAcquired = downloadInitiated || loggedIn && acquired && acquired.indexOf(asset.id) != -1;

          isNew = false;
          if (!isFav && !isAcquired) {
            isNew = nowDate - asset.created < days;
          }
          var assetSize = getAssetSize(asset);

          var userFree = userFreeAssets && userFreeAssets.indexOf(asset.id) != -1;
          var isArchviz = _this5.props.location.pathname.indexOf('library/archviz') > -1;

          return _react2.default.createElement(_AssetsGridItem2.default, {
            isMegascan: true,
            name: assetName,
            tags: asset.tags.map(function (t) {
              return { name: t, to: isArchviz ? '/megascans/library/archviz?search=' + t : '/megascans/library?search=' + t };
            }),
            type: asset.categories[0],
            assetType: assetType,
            typeColor: typeColor,
            is3D: is3D,
            categories: asset.categories,
            points: asset.points,
            physicalSize: asset.physicalSize,
            isNew: isNew,
            isOwned: isAcquired,
            isFavorited: isFav,
            userFree: userFree,
            remainingTimeInMills: remainingTimeInMills,
            onFavoriteToggle: _this5.handleFavoriteToggle,
            isDownloaded: false,
            onDownloadClick: _this5.handleDownloadClick,
            isDownloading: isDownloading,
            isLoggedIn: loggedIn,
            id: asset.id,
            key: asset.id,
            to: { pathname: '/assets/' + asset.id, state: { modal: true } },
            lowResImg: asset.previews.images.tiny,
            imgAspectRatio: aspectRatio,
            img: uri,
            smuri: smuri,
            cols: assetSize.cols,
            rows: assetSize.rows,
            onClick: function onClick() {
              return ga && ga('send', 'event', 'view', 'assets', assetName + ' ' + asset.id, asset.id);
            },
            isUnlimited: !!_ramda2.default.pathOr(0, ['quota', 'isUnlimited'], user)
          });
        })
      ) : !isLoading && !loadingFeatured ? _react2.default.createElement(
        'div',
        { className: (0, _glamor.css)({ display: 'flex', justifyContent: 'center', width: '100%', height: '80vh', overflow: 'auto' }) },
        _react2.default.createElement(
          'div',
          { className: noneFoundMessage },
          _react2.default.createElement('span', { className: icon }),
          _react2.default.createElement(
            'span',
            { className: boldText },
            'sorry, NO matches were found'
          ),
          _react2.default.createElement(
            'span',
            { className: (0, _glamor.css)(_fonts.p1, { paddingLeft: (0, _css.unitRem)(0.7), paddingRight: (0, _css.unitRem)(0.7), color: _css.pallets.gray_text }) },
            'Please try changing the filters or broadening your search.'
          ),
          _react2.default.createElement(
            'div',
            { className: promotionalContainer },
            _react2.default.createElement(_YoutubeTutorialBanner2.default, {
              logo: 'https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/mixer_icon_2048_preview.png',
              title: 'have you tried mixer yet?',
              description: 'With Quixel Mixer, you can create your own custom materials in minutes!',
              link: {
                to: '/mixer',
                iconType: 'download',
                linkLable: 'download now'
              },
              images: [{
                img: 'https://quixel-megascans-static.s3-us-west-2.amazonaws.com/megascans/bridge/stylised-planks-procedural-preview.jpg',
                to: 'https://youtu.be/QGnnrdKWJkk'
              }, {
                img: 'https://quixel-megascans-static.s3-us-west-2.amazonaws.com/megascans/bridge/creating-an-obsidian-material.jpg',
                to: 'https://youtu.be/acgTyUVpoiE'
              }, {
                img: 'https://quixel-megascans-static.s3-us-west-2.amazonaws.com/megascans/bridge/corrugated-metal.jpg',
                to: 'https://youtu.be/XZiUdMYJC5Q'
              }]
            })
          )
        )
      ) : null;
    }
  }]);
  return AssetsGrid;
}(_react2.default.Component), _class2.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = AssetsGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetsGrid/AssetsGrid.jsx
// module id = 646
// module chunks = 0